import { resizeTextBoundary } from '../../../drawing/utils'

export function keyPress(event) {
  event.preventDefault()

  if (!this.selectedItem) return
  const { selectedItem } = this

  const boundary = selectedItem.getBoundary()
  const params = selectedItem.getParams()

  if (event.key.toLowerCase() === 'enter') {
    params.text =
      params.text.slice(0, params.cursorPosition) + '/n' + params.text.slice(params.cursorPosition)
    params.cursorPosition += 2
  } else {
    let char = String.fromCharCode(event.keyCode)

    if (!char && char !== ' ') return
    if (!event.shiftKey) char = char.toLowerCase()

    params.text =
      params.text.slice(0, params.cursorPosition) + char + params.text.slice(params.cursorPosition)
    params.cursorPosition += 1
  }

  let updatedBoundary = false
  const ctx = this.canvas.getContext('2d')
  const { width, height } = resizeTextBoundary(params.text, ctx)

  if (boundary.width < width + 8) {
    boundary.width = width + 8
    updatedBoundary = true
  }

  if (boundary.height < height) {
    boundary.height = height
    updatedBoundary = true
  }

  selectedItem.setParams(params)

  this.textResizeOptions.minWidth = width > 100 ? width + 8 : 100
  this.textResizeOptions.minHeight = height > 28 ? height : 28

  if (updatedBoundary) selectedItem.setBoundary(boundary)

  this.engine.reRender()
}



// WEBPACK FOOTER //
// ./src/components/ScreenshotEditor/keyboardActions/keyPress.js